export default __webpack_public_path__ + "3d8eb3dbc191bcb221dc85ef129cf3b5.svg";